import { gql, TypedDocumentNode } from '@apollo/client'
import { UserFindRequest } from '../type/user-query'
import { QueryPageableRequest, QueryPageableResponse } from '../../../core/type'
import { User } from '../type'

export const GetUserAuthenticated = gql`
    query GetUserAuthenticated {
        userAuthenticated {
            id
            name
            name
            status
        }
    }
`

export const GetUsers: TypedDocumentNode<QueryPageableResponse<User, 'usersFind'>, QueryPageableRequest<UserFindRequest>> = gql`
    query GetUsers($request: UserFindRequest!) {
        usersFind(request: $request) {
            data {
                id
                createdAt
                name
                firstName
                lastName
                email
                phone
                status
                relatedContact {
                    contactId
                }
            }
            count
        }
    }
`